import { defineMessages } from "react-intl"

const messages = defineMessages({
  documentsTab: {
    defaultMessage: "Your documents",
    id: "documents.tab.documents.title"
  },
  statementsTab: {
    defaultMessage: "Your statements",
    id: "statement.page.title"
  },
  formsTab: {
    defaultMessage: "Your forms ({formsNb})",
    id: "documents.tab.forms.title"
  }
})

export default [
  { title: messages.documentsTab, location: "/documents" },
  { title: messages.statementsTab, location: "/documents/statements" },
  { title: messages.formsTab, location: "/documents/forms" }
]
